import { graphql } from '@/generated/gql';

export const LOAD_COLUMN_CONFIG_QUERY = graphql(/* GraphQL */ `
  query LoadColumnConfig($domain: String!) {
    baseColumnConfig(where: { domain: { _eq: $domain } }) {
      id
      domain
      config
      userId
    }
  }
`);
